<template>
  <c-spinner data-cy="spinner" class="loading-spinner" :size="size" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { CSpinner } from "@chakra-ui/vue";

export default defineComponent({
  name: "Spinner",
  components: {
    CSpinner,
  },
  props: {
    size: {
      type: String,
      default: "md",
      validator: (value: any) => {
        return value.match(/(xs|sm|md|lg)/);
      },
    },
  },
});
</script>

<style scoped lang="scss">
@import "../design-system/assets/tokens/tokens";

.loading-spinner {
  -webkit-animation: spinner-animation 0.45s linear infinite;
  animation: spinner-animation 0.45s linear infinite;
}

// add spinner animation manually here since chakra-ui animation
// doesn't work in built images but works locally for some unknown reason
@keyframes spinner-animation {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
